import { IPond } from '../../interfaces/ipond';
import { Asset } from '../asset';
import { AssetTeam } from '../asset-team';

export class PondBase {
  PondId: number;
  AssetId: number | null;
  AssetTeamId: number | null;
  Name: string | null;
  Location: object | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Asset?: Asset;
  AssetTeam?: AssetTeam;

  constructor(item?: IPond) {
    if (item) {

      this.PondId = item.PondId;
      this.AssetId = item.AssetId;
      this.AssetTeamId = item.AssetTeamId;
      this.Name = item.Name;
      this.Location = item.Location;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Asset = new Asset(item.Asset);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
    }
  }
}